import React, {PropTypes as T} from 'react';

const SadTicketIcon = ({ width = 43, height = 86, color, className = '' }) => (
  <svg
    aria-label="Ticket Icon"
    viewBox="0 0 43 86"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__sadticket ${className}`}>
    <path style={{fillRule: 'evenodd'}}
      d="M43 53.75V4.913C43 2.199 41.076 0 38.7 0H26.875A5.374 5.374 0 0 1 21.5 5.375 5.374
      5.374 0 0 1 16.125 0H4.3C1.926 0 0 2.2 0 4.913V53.75h2.15v2.15H0v25.187C0 83.801 1.926 86 4.3
      86h11.825a5.374 5.374 0 0 1 5.375-5.375A5.374 5.374 0 0 1 26.875 86H38.7c2.376 0 4.3-2.2
      4.3-4.913V55.9h-2.15v-2.15H43zM26.43 15.68c.84-.84 2.2-.84 3.04 0 .84.84.84 2.2 0
      3.04-.84.84-2.2.84-3.04 0-.84-.84-.84-2.2 0-3.04zm-12.9 0c.84-.84 2.2-.84 3.04 0
      .84.84.84 2.2 0 3.04-.84.84-2.2.84-3.04 0-.84-.84-.84-2.2 0-3.04zM6.45 53.75h4.3v2.15h-4.3
      v-2.15zm8.6 0h4.3v2.15h-4.3v-2.15zm-4.3-26.755s13.637-1.625 21.5 7.138c0 0-9.716-5.979-21.5-7.138z
      m12.9 26.755h4.3v2.15h-4.3v-2.15zm8.6 0h4.3v2.15h-4.3v-2.15z" />
  </svg>
);

SadTicketIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  SadTicketIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_sad_ticket.js